/* ============================================================
   VANDA'S KITCHEN — CUSTOMER DASHBOARD JS
   ------------------------------------------------------------
   FILE: assets/vk-customer-dashboard.js
   INSTALL: Shopify Admin → Online Store → Themes → Edit code
            → Assets → Add a new asset → name it
            "vk-customer-dashboard.js" → paste this whole file.
   ------------------------------------------------------------
   Loads the customer's tier, connections and savings from the
   Railway backend dashboard endpoint and renders them.
   ============================================================ */

(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function providerLabel(p) {
    var names = {
      microsoft: 'Microsoft 365',
      google: 'Google Workspace',
      slack: 'Slack',
      direct_api: 'Direct API',
      manual: 'Manual entry'
    };
    return names[p] || p;
  }

  function tierLabel(t) {
    var names = {
      standard: 'Standard',
      connected: 'Connected',
      returning: 'Returning',
      corporate: 'Corporate',
      premier: 'Premier',
      enterprise_pending: 'Enterprise (under review)',
      enterprise: 'Enterprise'
    };
    return names[t] || t;
  }

  function initDashboard() {
    var dash = $('.vk-dash');
    if (!dash) return;

    var api = dash.getAttribute('data-vk-api');
    var customerId = dash.getAttribute('data-customer-id');
    if (!customerId) return;

    var loadingEl = $('#vk-dash-loading');
    var contentEl = $('#vk-dash-content');
    var errorEl = $('#vk-dash-error');

    fetch(api + '/api/dashboard?shopify_customer_id=' + encodeURIComponent(customerId))
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        renderDashboard(data);
        loadingEl.hidden = true;
        contentEl.hidden = false;
      })
      .catch(function () {
        loadingEl.hidden = true;
        errorEl.hidden = false;
      });
  }

  function renderDashboard(data) {
    var customer = data.customer || {};
    var stats = data.lifetime_stats || {};
    var connections = data.connections || [];
    var tierProgress = data.tier_progress || {};
    var nextActions = data.next_actions || [];

    // Tier
    $('#vk-dash-tier').textContent =
      customer.tier_display_name || tierLabel(customer.current_tier || 'standard');

    // Tier progress
    if (tierProgress.next_tier_display &&
        typeof tierProgress.closest_progress_percentage === 'number') {
      var pe = $('#vk-dash-tier-progress');
      pe.hidden = false;
      $('#vk-dash-progress-fill').style.width =
        tierProgress.closest_progress_percentage + '%';
      var descs = tierProgress.progress_descriptions || [];
      $('#vk-dash-progress-text').textContent =
        'Next tier: ' + tierProgress.next_tier_display +
        (descs.length ? ' — ' + descs[0] : '');
    }

    // Stats
    $('#vk-dash-orders').textContent = stats.orders_count || 0;
    $('#vk-dash-spend').textContent =
      '£' + Math.round(stats.total_spend_gbp || 0).toLocaleString('en-GB');
    $('#vk-dash-savings').textContent =
      '£' + Math.round(stats.estimated_savings_gbp || 0).toLocaleString('en-GB');

    // Connections
    var connEl = $('#vk-dash-connections');
    connEl.innerHTML = '';
    var active = connections.filter(function (c) { return c.status === 'active'; });
    if (active.length === 0) {
      var li0 = document.createElement('li');
      li0.textContent = 'No calendars connected yet.';
      connEl.appendChild(li0);
    } else {
      active.forEach(function (c) {
        var li = document.createElement('li');
        li.className = 'vk-dash__connection vk-dash__connection--active';
        li.textContent = providerLabel(c.provider) + ' — connected';
        connEl.appendChild(li);
      });
    }

    // Next actions
    var actEl = $('#vk-dash-actions');
    actEl.innerHTML = '';
    nextActions.forEach(function (a) {
      var li = document.createElement('li');
      li.textContent = a;
      actEl.appendChild(li);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDashboard);
  } else {
    initDashboard();
  }

})();